export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      about: "À propos",
      network: "Réseau Continental",
      programs: "Programmes",
      publications: "Publications",
      partners: "Partenaires",
      contact: "Contact",
      membership: "Adhésion",
      apply: "Candidature",
      donate: "Faire un don",
    },
    // Hero Section
    hero: {
      overline: "Plateforme Stratégique Afrique – Monde Russophone",
      title: "L'Architecture Africaine de la Coopération Russophone",
      subtitle: "Langue – Savoir – Diplomatie – Développement – Souveraineté",
      description: "Dans un monde en recomposition géopolitique, l'Afrique redéfinit ses alliances, diversifie ses partenariats et affirme sa souveraineté stratégique.",
      cta_primary: "Découvrir nos programmes",
      cta_secondary: "Devenir membre",
    },
    // Strategic Narrative
    narrative: {
      title: "Notre Mission Continentale",
      text: "L'Organisation Africaine de la Russophonie (OAR) se positionne comme la plateforme continentale dédiée à la coopération linguistique, académique, culturelle et économique entre l'Afrique et le monde russophone. OAR agit comme catalyseur de formation, de transfert de compétences, de dialogue stratégique et de partenariat durable.",
    },
    // Continental Map Section
    map: {
      title: "Réseau Continental Stratégique",
      description: "L'OAR structure un réseau continental reliant les capitales africaines aux centres universitaires, technologiques et industriels du monde russophone.",
      legend: {
        member: "Pays membres",
        observer: "Pays observateurs",
        candidate: "Pays candidats",
      },
    },
    // Five Pillars
    pillars: {
      title: "Les 5 Piliers Stratégiques",
      subtitle: "Notre vision multipolaire repose sur cinq axes fondamentaux de coopération",
      pillar1: {
        title: "Diplomatie Linguistique",
        description: "Promotion du russe comme langue stratégique alternative sur le continent africain. Un Africain parlant plusieurs langues est supérieur à un autre qui n'en parle qu'une seule.",
      },
      pillar2: {
        title: "Coopération Académique",
        description: "Mobilité étudiante, bourses d'excellence, reconnaissance mutuelle des diplômes.",
      },
      pillar3: {
        title: "Transfert Technologique",
        description: "Ingénierie, énergie, numérique, défense civile et innovations industrielles.",
      },
      pillar4: {
        title: "Diplomatie Économique",
        description: "Corridors commerciaux, investissements croisés, partenariats d'entreprises.",
      },
      pillar5: {
        title: "Think Tank Multipolaire",
        description: "Analyses stratégiques sur les relations Afrique–BRICS–Eurasie.",
      },
    },
    // Think Tank
    thinkTank: {
      title: "Centre d'Analyses Stratégiques",
      description: "OAR publie des analyses stratégiques sur les relations Afrique–Russie, l'intégration aux BRICS, et les dynamiques multipolaires qui façonnent le nouvel ordre mondial.",
      cta: "Consulter nos publications",
    },
    // Newsletter
    newsletter: {
      title: "Restez Informés",
      description: "Recevez nos analyses stratégiques et actualités de la coopération Afrique-Russophonie.",
      placeholder: "Votre adresse email",
      button: "S'abonner",
      success: "Inscription réussie !",
      error: "Erreur lors de l'inscription",
    },
    // Footer
    footer: {
      tagline: "Plateforme stratégique pour la coopération Afrique–Monde Russophone",
      quickLinks: "Liens Rapides",
      contact: "Contact",
      followUs: "Suivez-nous",
      rights: "Tous droits réservés",
      headquarters: "Siège: Bangui, République Centrafricaine",
    },
    // About Page
    about: {
      title: "À Propos de l'OAR",
      subtitle: "Une institution au service de la souveraineté africaine",
      vision: {
        title: "Vision 2040",
        text: "D'ici 2040, l'OAR vise à établir un réseau de 50 pays africains intégrés dans l'espace russophone, formant une nouvelle architecture de coopération Sud-Sud basée sur le respect mutuel et les intérêts partagés.",
      },
      council: {
        title: "Conseil Stratégique",
        text: "Le Conseil Stratégique de l'OAR réunit des personnalités éminentes du monde diplomatique, académique et économique africain et russophone.",
      },
      governance: {
        title: "Charte de Gouvernance",
        text: "L'OAR est régie par une charte de gouvernance garantissant la transparence, l'équité et la représentation de tous les États membres.",
      },
      committee: {
        title: "Comité Scientifique",
        text: "Notre comité scientifique rassemble des experts reconnus pour orienter nos programmes de recherche et d'analyse stratégique.",
      },
      history: {
        title: "Notre Histoire",
        text: "Créée en août 2022 en République Centrafricaine, l'Organisation Africaine de la Russophonie est née de la volonté des nations africaines de diversifier leurs partenariats stratégiques.",
      },
      objectives: {
        title: "Objectifs à 5 Ans",
        obj1: "25 pays africains représentés",
        obj2: "50 universités partenaires Russes et BRICS",
        obj3: "10 000 étudiants mobilisés",
        obj4: "1 Forum Afrique–Russophonie annuel",
        obj5: "1 Rapport stratégique publié chaque année",
      },
    },
    // Programs Page
    programs: {
      title: "Nos Programmes",
      subtitle: "Des initiatives stratégiques pour le développement continental",
      program1: {
        title: "Programme 10 000 Étudiants Russophones",
        subtitle: "Horizon 2035",
        description: "Former 10 000 étudiants africains dans les universités russes et des pays BRICS d'ici 2035, créant une nouvelle génération de cadres multilingues.",
        features: ["Bourses d'excellence", "Cours de langue russe", "Accompagnement culturel", "Insertion professionnelle"],
      },
      program2: {
        title: "Programme Entreprises Afrique–Russie",
        subtitle: "Coopération Économique",
        description: "Faciliter les échanges commerciaux et les investissements croisés entre entreprises africaines et russes.",
        features: ["Missions économiques", "Forums d'affaires", "Financement de projets", "Assistance juridique"],
      },
      program3: {
        title: "Programme Jeunes Diplomates",
        subtitle: "Formation d'Excellence",
        description: "Former la prochaine génération de diplomates africains aux enjeux des relations multipolaires.",
        features: ["Séminaires diplomatiques", "Stages en ambassades", "Simulations ONU", "Réseau international"],
      },
    },
    // Publications Page
    publications: {
      title: "Publications",
      subtitle: "Analyses et rapports stratégiques",
      categories: {
        all: "Toutes",
        rapport: "Rapports Annuels",
        note_strategique: "Notes Stratégiques",
        analyse_geopolitique: "Analyses Géopolitiques",
      },
      readMore: "Lire la suite",
      views: "vues",
      noArticles: "Aucune publication disponible pour le moment.",
    },
    // Partners Page
    partners: {
      title: "Nos Partenaires",
      subtitle: "Un réseau d'institutions de premier plan",
      categories: {
        all: "Tous",
        universite_russe: "Universités Russes",
        institution_africaine: "Institutions Africaines",
        chambre_commerce: "Chambres de Commerce",
        think_tank: "Think Tanks",
      },
      visitWebsite: "Visiter le site",
    },
    // Contact Page
    contact: {
      title: "Contactez-nous",
      subtitle: "Nous sommes à votre écoute",
      form: {
        name: "Nom complet",
        email: "Adresse email",
        organization: "Organisation (optionnel)",
        subject: "Sujet",
        message: "Votre message",
        submit: "Envoyer le message",
        success: "Message envoyé avec succès !",
        error: "Erreur lors de l'envoi",
      },
      info: {
        title: "Informations de Contact",
        address: "Siège Social",
        addressValue: "Bangui, République Centrafricaine",
        email: "Email",
        phone: "Téléphone",
      },
    },
    // Network Page
    network: {
      title: "Réseau Continental",
      subtitle: "Présence panafricaine et partenariats mondiaux",
      representations: {
        title: "Représentations Nationales",
        description: "L'OAR dispose de représentations dans plusieurs pays africains, coordonnant les activités locales et facilitant les échanges.",
      },
      centers: {
        title: "Centres Partenaires",
        description: "Des centres de formation et de coopération établis en partenariat avec des institutions locales.",
      },
      universities: {
        title: "Universités Affiliées",
        description: "Un réseau d'universités partenaires en Russie et dans les pays BRICS offrant des programmes aux étudiants africains.",
      },
    },
    // Common
    common: {
      learnMore: "En savoir plus",
      backToHome: "Retour à l'accueil",
      loading: "Chargement...",
    },
    // Membership Page
    membership: {
      heroTitle: "Rejoignez l'Architecture Africaine de la Coopération Russophone",
      heroSubtitle: "L'OAR rassemble la nouvelle génération de leaders, d'étudiants et d'entrepreneurs africains connectés au monde russophone d'égal à égal.",
      formulas: "Nos Formules d'Adhésion",
      standard: {
        title: "Membre Étudiant / Standard",
        price: "10",
        period: "USD / an",
        tagline: "Accessible. Stratégique. Visionnaire.",
        benefits: [
          "Accès prioritaire aux informations sur les bourses russes",
          "Orientation académique vers universités partenaires",
          "Invitation aux webinaires géopolitiques OAR",
          "Newsletter stratégique mensuelle",
          "Certificat officiel numérique de membre",
          "Intégration dans le réseau national OAR de votre pays"
        ],
        cvPosition: "Positionnement CV: Membre de l'Organisation Africaine de la Russophonie (OAR)"
      },
      premium: {
        title: "Membre Premium",
        price: "25",
        period: "USD / an",
        tagline: "Prioritaire. Connecté. Influant.",
        allStandard: "Tous les avantages Standard +",
        benefits: [
          "Accès prioritaire aux opportunités académiques avancées",
          "Mise en relation avec partenaires économiques et experts",
          "Accès aux rapports stratégiques complets OAR",
          "Invitation prioritaire aux événements physiques",
          "Badge numérique Premium vérifiable",
          "Possibilité de devenir coordinateur local"
        ],
        limited: "Places limitées",
        remaining: "places restantes cette année"
      },
      whyJoin: {
        title: "Pourquoi adhérer à l'OAR ?",
        subtitle: "Parce que le monde change. Et ceux qui anticipent les nouvelles alliances prennent de l'avance.",
        points: [
          "Dans un réseau continental",
          "Dans une dynamique multipolaire",
          "Dans une logique d'opportunités concrètes"
        ],
        positioning: "L'OAR vous positionne :"
      },
      countryBenefits: {
        title: "Avantages dans votre pays",
        intro: "En devenant membre OAR dans votre pays :",
        points: [
          "Vous intégrez le réseau officiel local",
          "Vous participez aux rencontres nationales",
          "Vous accédez aux opportunités éducatives et économiques",
          "Vous devenez un relais stratégique Afrique–Russophonie"
        ],
        network: "L'OAR fonctionne par réseau continental structuré. Chaque pays devient un pôle."
      },
      form: {
        title: "Formulaire d'adhésion",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email",
        phone: "Téléphone",
        country: "Pays",
        city: "Ville",
        profession: "Profession",
        organization: "Organisation",
        membershipType: "Type d'adhésion",
        paymentMethod: "Méthode de paiement",
        card: "Carte Visa / Mastercard",
        crypto: "Crypto (USDT TRC20)",
        submit: "Procéder au paiement",
        processing: "Traitement en cours..."
      },
      payment: {
        title: "Paiement",
        methods: "Méthodes acceptées :",
        secure: "Paiement sécurisé.",
        afterPayment: "Après paiement :",
        steps: [
          "Email automatique de confirmation",
          "Numéro de membre unique",
          "Certificat PDF officiel",
          "Accès espace membre"
        ]
      },
      crypto: {
        title: "Paiement Crypto",
        instructions: "Envoyez le montant exact à l'adresse suivante :",
        network: "Réseau: USDT TRC20",
        amount: "Montant:",
        address: "Adresse wallet:",
        confirm: "Après paiement, cliquez sur 'Confirmer le paiement'",
        confirmBtn: "J'ai effectué le paiement"
      },
      finalMessage: {
        title: "L'histoire ne se construit pas à la périphérie.",
        text: "Elle se construit au cœur des nouveaux équilibres mondiaux. L'OAR rassemble ceux qui veulent anticiper, comprendre et agir.",
        cta: "Rejoignez le réseau continental dès aujourd'hui."
      },
      membersByCountry: "Membres par pays",
      success: {
        title: "Adhésion réussie !",
        memberNumber: "Votre numéro de membre :",
        emailSent: "Un email de confirmation a été envoyé.",
        certificate: "Votre certificat sera disponible dans votre espace membre."
      }
    },
    // WhatsApp Section
    whatsapp: {
      title: "Rejoignez notre communauté WhatsApp",
      description: "Restez connectés avec l'OAR. Recevez les dernières actualités, opportunités et événements directement sur votre téléphone.",
      cta: "Rejoindre la chaîne",
      community: "Communauté continentale",
      updates: "Actualités en temps réel",
    },
    // Student Application
    studentApplication: {
      title: "Programme 10 000 Étudiants Russophones",
      subtitle: "Postulez pour étudier dans les universités russes et BRICS",
      form: {
        personalInfo: "Informations personnelles",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email",
        phone: "Téléphone",
        dateOfBirth: "Date de naissance",
        country: "Pays",
        city: "Ville",
        academicInfo: "Informations académiques",
        currentLevel: "Niveau d'études actuel",
        levels: {
          lycee: "Lycée / Baccalauréat",
          licence: "Licence",
          master: "Master",
          doctorat: "Doctorat"
        },
        fieldOfStudy: "Domaine d'études",
        targetDegree: "Diplôme visé",
        preferredUniversities: "Universités préférées",
        russianLevel: "Niveau de russe",
        russianLevels: {
          debutant: "Débutant",
          intermediaire: "Intermédiaire",
          avance: "Avancé"
        },
        motivation: "Lettre de motivation",
        submit: "Soumettre ma candidature",
        success: "Candidature soumise avec succès !",
        applicationNumber: "Numéro de candidature :"
      }
    },
    // Donate Page
    donate: {
      title: "Faire un Don",
      subtitle: "Vous voulez nous soutenir, soutenir nos initiatives, programmes ou activités sans devenir membre ? Faites un don et contribuez à notre mission.",
      description: "Votre générosité nous aide à poursuivre notre mission de coopération entre l'Afrique et le monde russophone. Chaque contribution, quelle que soit sa taille, fait une différence dans la vie de milliers d'étudiants et de professionnels africains.",
      cardPayment: "Paiement par carte",
      cardDescription: "Payez facilement et en toute sécurité avec votre carte Visa ou Mastercard via Paystack.",
      cryptoPayment: "Paiement Crypto",
      cryptoDescription: "Faites un don en cryptomonnaie USDT sur le réseau TRC20 (Tron).",
      cardTitle: "Don par Carte Bancaire",
      cardInstructions: "Cliquez sur le bouton ci-dessous pour effectuer votre don sécurisé via Paystack.",
      cardButton: "Faire un don maintenant",
      securePayment: "Paiement sécurisé par Paystack",
      cryptoTitle: "Don en Cryptomonnaie",
      network: "Réseau",
      walletAddress: "Adresse du portefeuille",
      copied: "Adresse copiée !",
      scanQR: "Scannez le QR code pour envoyer votre don",
      important: "Important",
      cryptoWarning: "Envoyez uniquement des USDT sur le réseau TRC20 (Tron). L'envoi d'autres cryptomonnaies peut entraîner une perte de fonds.",
      thankYou: "Merci pour votre générosité et votre soutien à notre mission !",
    },
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About",
      network: "Continental Network",
      programs: "Programs",
      publications: "Publications",
      partners: "Partners",
      contact: "Contact",
      membership: "Membership",
      apply: "Apply",
      donate: "Donate",
    },
    // Hero Section
    hero: {
      overline: "Strategic Platform Africa – Russophone World",
      title: "The African Architecture of Russophone Cooperation",
      subtitle: "Language – Knowledge – Diplomacy – Development – Sovereignty",
      description: "In a world undergoing geopolitical recomposition, Africa redefines its alliances, diversifies its partnerships and affirms its strategic sovereignty.",
      cta_primary: "Discover our programs",
      cta_secondary: "Become a member",
    },
    // Strategic Narrative
    narrative: {
      title: "Our Continental Mission",
      text: "The African Organization of Russophony (OAR) positions itself as the continental platform dedicated to linguistic, academic, cultural and economic cooperation between Africa and the Russophone world. OAR acts as a catalyst for training, skills transfer, strategic dialogue and lasting partnership.",
    },
    // Continental Map Section
    map: {
      title: "Strategic Continental Network",
      description: "OAR structures a continental network linking African capitals to the university, technological and industrial centers of the Russophone world.",
      legend: {
        member: "Member countries",
        observer: "Observer countries",
        candidate: "Candidate countries",
      },
    },
    // Five Pillars
    pillars: {
      title: "The 5 Strategic Pillars",
      subtitle: "Our multipolar vision is based on five fundamental axes of cooperation",
      pillar1: {
        title: "Linguistic Diplomacy",
        description: "Promotion of Russian as an alternative strategic language on the African continent. An African speaking multiple languages is superior to one who speaks only one.",
      },
      pillar2: {
        title: "Academic Cooperation",
        description: "Student mobility, excellence scholarships, mutual recognition of diplomas.",
      },
      pillar3: {
        title: "Technology Transfer",
        description: "Engineering, energy, digital, civil defense and industrial innovations.",
      },
      pillar4: {
        title: "Economic Diplomacy",
        description: "Commercial corridors, cross investments, business partnerships.",
      },
      pillar5: {
        title: "Multipolar Think Tank",
        description: "Strategic analyses on Africa–BRICS–Eurasia relations.",
      },
    },
    // Think Tank
    thinkTank: {
      title: "Strategic Analysis Center",
      description: "OAR publishes strategic analyses on Africa-Russia relations, BRICS integration, and the multipolar dynamics shaping the new world order.",
      cta: "View our publications",
    },
    // Newsletter
    newsletter: {
      title: "Stay Informed",
      description: "Receive our strategic analyses and news on Africa-Russophone cooperation.",
      placeholder: "Your email address",
      button: "Subscribe",
      success: "Successfully subscribed!",
      error: "Error during subscription",
    },
    // Footer
    footer: {
      tagline: "Strategic platform for Africa–Russophone World cooperation",
      quickLinks: "Quick Links",
      contact: "Contact",
      followUs: "Follow Us",
      rights: "All rights reserved",
      headquarters: "Headquarters: Bangui, Central African Republic",
    },
    // About Page
    about: {
      title: "About OAR",
      subtitle: "An institution serving African sovereignty",
      vision: {
        title: "Vision 2040",
        text: "By 2040, OAR aims to establish a network of 50 African countries integrated into the Russophone space, forming a new architecture of South-South cooperation based on mutual respect and shared interests.",
      },
      council: {
        title: "Strategic Council",
        text: "The OAR Strategic Council brings together eminent figures from the African and Russophone diplomatic, academic and economic world.",
      },
      governance: {
        title: "Governance Charter",
        text: "OAR is governed by a governance charter guaranteeing transparency, equity and representation of all member states.",
      },
      committee: {
        title: "Scientific Committee",
        text: "Our scientific committee brings together recognized experts to guide our research and strategic analysis programs.",
      },
      history: {
        title: "Our History",
        text: "Created in August 2022 in the Central African Republic, the African Organization of Russophony was born from the will of African nations to diversify their strategic partnerships.",
      },
      objectives: {
        title: "5-Year Objectives",
        obj1: "25 African countries represented",
        obj2: "50 partner Russian and BRICS universities",
        obj3: "10,000 students mobilized",
        obj4: "1 annual Africa–Russophony Forum",
        obj5: "1 strategic report published each year",
      },
    },
    // Programs Page
    programs: {
      title: "Our Programs",
      subtitle: "Strategic initiatives for continental development",
      program1: {
        title: "10,000 Russian-speaking Students Program",
        subtitle: "Horizon 2035",
        description: "Train 10,000 African students in Russian and BRICS universities by 2035, creating a new generation of multilingual executives.",
        features: ["Excellence scholarships", "Russian language courses", "Cultural support", "Professional integration"],
      },
      program2: {
        title: "Africa-Russia Business Program",
        subtitle: "Economic Cooperation",
        description: "Facilitate trade exchanges and cross investments between African and Russian companies.",
        features: ["Economic missions", "Business forums", "Project financing", "Legal assistance"],
      },
      program3: {
        title: "Young Diplomats Program",
        subtitle: "Excellence Training",
        description: "Train the next generation of African diplomats on multipolar relations issues.",
        features: ["Diplomatic seminars", "Embassy internships", "UN simulations", "International network"],
      },
    },
    // Publications Page
    publications: {
      title: "Publications",
      subtitle: "Strategic analyses and reports",
      categories: {
        all: "All",
        rapport: "Annual Reports",
        note_strategique: "Strategic Notes",
        analyse_geopolitique: "Geopolitical Analyses",
      },
      readMore: "Read more",
      views: "views",
      noArticles: "No publications available at the moment.",
    },
    // Partners Page
    partners: {
      title: "Our Partners",
      subtitle: "A network of leading institutions",
      categories: {
        all: "All",
        universite_russe: "Russian Universities",
        institution_africaine: "African Institutions",
        chambre_commerce: "Chambers of Commerce",
        think_tank: "Think Tanks",
      },
      visitWebsite: "Visit website",
    },
    // Contact Page
    contact: {
      title: "Contact Us",
      subtitle: "We are listening",
      form: {
        name: "Full name",
        email: "Email address",
        organization: "Organization (optional)",
        subject: "Subject",
        message: "Your message",
        submit: "Send message",
        success: "Message sent successfully!",
        error: "Error sending message",
      },
      info: {
        title: "Contact Information",
        address: "Headquarters",
        addressValue: "Bangui, Central African Republic",
        email: "Email",
        phone: "Phone",
      },
    },
    // Network Page
    network: {
      title: "Continental Network",
      subtitle: "Pan-African presence and global partnerships",
      representations: {
        title: "National Representations",
        description: "OAR has representations in several African countries, coordinating local activities and facilitating exchanges.",
      },
      centers: {
        title: "Partner Centers",
        description: "Training and cooperation centers established in partnership with local institutions.",
      },
      universities: {
        title: "Affiliated Universities",
        description: "A network of partner universities in Russia and BRICS countries offering programs to African students.",
      },
    },
    // Common
    common: {
      learnMore: "Learn more",
      backToHome: "Back to home",
      loading: "Loading...",
    },
    // Membership Page
    membership: {
      heroTitle: "Join the African Architecture of Russophone Cooperation",
      heroSubtitle: "OAR brings together the new generation of African leaders, students and entrepreneurs connected to the Russophone world as equals.",
      formulas: "Our Membership Plans",
      standard: {
        title: "Student / Standard Member",
        price: "10",
        period: "USD / year",
        tagline: "Accessible. Strategic. Visionary.",
        benefits: [
          "Priority access to Russian scholarship information",
          "Academic guidance to partner universities",
          "Invitation to OAR geopolitical webinars",
          "Monthly strategic newsletter",
          "Official digital membership certificate",
          "Integration into OAR national network in your country"
        ],
        cvPosition: "CV Positioning: Member of the African Organization of Russophony (OAR)"
      },
      premium: {
        title: "Premium Member",
        price: "25",
        period: "USD / year",
        tagline: "Priority. Connected. Influential.",
        allStandard: "All Standard benefits +",
        benefits: [
          "Priority access to advanced academic opportunities",
          "Connection with economic partners and experts",
          "Access to complete OAR strategic reports",
          "Priority invitation to physical events",
          "Verifiable Premium digital badge",
          "Opportunity to become local coordinator"
        ],
        limited: "Limited spots",
        remaining: "spots remaining this year"
      },
      whyJoin: {
        title: "Why join OAR?",
        subtitle: "Because the world is changing. And those who anticipate new alliances get ahead.",
        points: [
          "In a continental network",
          "In a multipolar dynamic",
          "In a logic of concrete opportunities"
        ],
        positioning: "OAR positions you:"
      },
      countryBenefits: {
        title: "Benefits in your country",
        intro: "By becoming an OAR member in your country:",
        points: [
          "You join the official local network",
          "You participate in national meetings",
          "You access educational and economic opportunities",
          "You become a strategic relay Africa-Russophony"
        ],
        network: "OAR operates through a structured continental network. Each country becomes a hub."
      },
      form: {
        title: "Membership Form",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phone: "Phone",
        country: "Country",
        city: "City",
        profession: "Profession",
        organization: "Organization",
        membershipType: "Membership Type",
        paymentMethod: "Payment Method",
        card: "Visa / Mastercard Card",
        crypto: "Crypto (USDT TRC20)",
        submit: "Proceed to Payment",
        processing: "Processing..."
      },
      payment: {
        title: "Payment",
        methods: "Accepted methods:",
        secure: "Secure payment.",
        afterPayment: "After payment:",
        steps: [
          "Automatic confirmation email",
          "Unique member number",
          "Official PDF certificate",
          "Member area access"
        ]
      },
      crypto: {
        title: "Crypto Payment",
        instructions: "Send the exact amount to the following address:",
        network: "Network: USDT TRC20",
        amount: "Amount:",
        address: "Wallet address:",
        confirm: "After payment, click 'Confirm payment'",
        confirmBtn: "I have made the payment"
      },
      finalMessage: {
        title: "History is not built on the periphery.",
        text: "It is built at the heart of new global balances. OAR brings together those who want to anticipate, understand and act.",
        cta: "Join the continental network today."
      },
      membersByCountry: "Members by country",
      success: {
        title: "Membership successful!",
        memberNumber: "Your member number:",
        emailSent: "A confirmation email has been sent.",
        certificate: "Your certificate will be available in your member area."
      }
    },
    // WhatsApp Section
    whatsapp: {
      title: "Join our WhatsApp community",
      description: "Stay connected with OAR. Receive the latest news, opportunities and events directly on your phone.",
      cta: "Join the channel",
      community: "Continental community",
      updates: "Real-time updates",
    },
    // Student Application
    studentApplication: {
      title: "10,000 Russian-speaking Students Program",
      subtitle: "Apply to study at Russian and BRICS universities",
      form: {
        personalInfo: "Personal Information",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phone: "Phone",
        dateOfBirth: "Date of Birth",
        country: "Country",
        city: "City",
        academicInfo: "Academic Information",
        currentLevel: "Current education level",
        levels: {
          lycee: "High School / Baccalaureate",
          licence: "Bachelor's",
          master: "Master's",
          doctorat: "Doctorate"
        },
        fieldOfStudy: "Field of Study",
        targetDegree: "Target Degree",
        preferredUniversities: "Preferred Universities",
        russianLevel: "Russian Level",
        russianLevels: {
          debutant: "Beginner",
          intermediaire: "Intermediate",
          avance: "Advanced"
        },
        motivation: "Motivation Letter",
        submit: "Submit Application",
        success: "Application submitted successfully!",
        applicationNumber: "Application number:"
      }
    },
    // Donate Page
    donate: {
      title: "Make a Donation",
      subtitle: "Want to support us, our initiatives, programs or activities without becoming a member? Make a donation and contribute to our mission.",
      description: "Your generosity helps us continue our mission of cooperation between Africa and the Russophone world. Every contribution, regardless of size, makes a difference in the lives of thousands of African students and professionals.",
      cardPayment: "Card Payment",
      cardDescription: "Pay easily and securely with your Visa or Mastercard via Paystack.",
      cryptoPayment: "Crypto Payment",
      cryptoDescription: "Donate in USDT cryptocurrency on the TRC20 network (Tron).",
      cardTitle: "Bank Card Donation",
      cardInstructions: "Click the button below to make your secure donation via Paystack.",
      cardButton: "Donate Now",
      securePayment: "Secure payment by Paystack",
      cryptoTitle: "Cryptocurrency Donation",
      network: "Network",
      walletAddress: "Wallet Address",
      copied: "Address copied!",
      scanQR: "Scan the QR code to send your donation",
      important: "Important",
      cryptoWarning: "Only send USDT on the TRC20 network (Tron). Sending other cryptocurrencies may result in loss of funds.",
      thankYou: "Thank you for your generosity and support of our mission!",
    },
  },
  ru: {
    // Navigation
    nav: {
      home: "Главная",
      about: "О нас",
      network: "Континентальная сеть",
      programs: "Программы",
      publications: "Публикации",
      partners: "Партнёры",
      contact: "Контакты",
      membership: "Членство",
      apply: "Заявка",
      donate: "Пожертвовать",
    },
    // Hero Section
    hero: {
      overline: "Стратегическая платформа Африка – Русскоязычный мир",
      title: "Африканская архитектура русскоязычного сотрудничества",
      subtitle: "Язык – Знания – Дипломатия – Развитие – Суверенитет",
      description: "В мире геополитической трансформации Африка переосмысливает свои альянсы, диверсифицирует партнёрства и утверждает свой стратегический суверенитет.",
      cta_primary: "Наши программы",
      cta_secondary: "Стать членом",
    },
    // Strategic Narrative
    narrative: {
      title: "Наша континентальная миссия",
      text: "Африканская организация русскоязычия (ОАР) позиционирует себя как континентальную платформу для языкового, академического, культурного и экономического сотрудничества между Африкой и русскоязычным миром. ОАР действует как катализатор обучения, передачи навыков, стратегического диалога и долгосрочного партнёрства.",
    },
    // Continental Map Section
    map: {
      title: "Стратегическая континентальная сеть",
      description: "ОАР формирует континентальную сеть, связывающую африканские столицы с университетскими, технологическими и промышленными центрами русскоязычного мира.",
      legend: {
        member: "Страны-члены",
        observer: "Страны-наблюдатели",
        candidate: "Страны-кандидаты",
      },
    },
    // Five Pillars
    pillars: {
      title: "5 стратегических столпов",
      subtitle: "Наше многополярное видение основано на пяти фундаментальных осях сотрудничества",
      pillar1: {
        title: "Языковая дипломатия",
        description: "Продвижение русского языка как альтернативного стратегического языка на африканском континенте. Африканец, говорящий на нескольких языках, превосходит того, кто говорит только на одном.",
      },
      pillar2: {
        title: "Академическое сотрудничество",
        description: "Студенческая мобильность, стипендии, взаимное признание дипломов.",
      },
      pillar3: {
        title: "Трансфер технологий",
        description: "Инженерия, энергетика, цифровые технологии, гражданская оборона и промышленные инновации.",
      },
      pillar4: {
        title: "Экономическая дипломатия",
        description: "Торговые коридоры, перекрёстные инвестиции, деловые партнёрства.",
      },
      pillar5: {
        title: "Многополярный аналитический центр",
        description: "Стратегический анализ отношений Африка–БРИКС–Евразия.",
      },
    },
    // Think Tank
    thinkTank: {
      title: "Центр стратегического анализа",
      description: "ОАР публикует стратегические анализы отношений Африка-Россия, интеграции в БРИКС и многополярной динамики, формирующей новый мировой порядок.",
      cta: "Наши публикации",
    },
    // Newsletter
    newsletter: {
      title: "Будьте в курсе",
      description: "Получайте наши стратегические анализы и новости о сотрудничестве Африка-Русскоязычие.",
      placeholder: "Ваш email",
      button: "Подписаться",
      success: "Подписка оформлена!",
      error: "Ошибка подписки",
    },
    // Footer
    footer: {
      tagline: "Стратегическая платформа сотрудничества Африка–Русскоязычный мир",
      quickLinks: "Быстрые ссылки",
      contact: "Контакты",
      followUs: "Следите за нами",
      rights: "Все права защищены",
      headquarters: "Штаб-квартира: Банги, Центральноафриканская Республика",
    },
    // About Page
    about: {
      title: "Об ОАР",
      subtitle: "Институт на службе африканского суверенитета",
      vision: {
        title: "Видение 2040",
        text: "К 2040 году ОАР стремится создать сеть из 50 африканских стран, интегрированных в русскоязычное пространство, формируя новую архитектуру сотрудничества Юг-Юг на основе взаимного уважения и общих интересов.",
      },
      council: {
        title: "Стратегический совет",
        text: "Стратегический совет ОАР объединяет выдающихся представителей африканского и русскоязычного дипломатического, академического и экономического мира.",
      },
      governance: {
        title: "Устав управления",
        text: "ОАР регулируется уставом, гарантирующим прозрачность, справедливость и представительство всех государств-членов.",
      },
      committee: {
        title: "Научный комитет",
        text: "Наш научный комитет объединяет признанных экспертов для руководства нашими исследовательскими и аналитическими программами.",
      },
      history: {
        title: "Наша история",
        text: "Созданная в августе 2022 года в Центральноафриканской Республике, Африканская организация русскоязычия родилась из стремления африканских наций диверсифицировать свои стратегические партнёрства.",
      },
      objectives: {
        title: "Цели на 5 лет",
        obj1: "25 представленных африканских стран",
        obj2: "50 партнёрских российских и БРИКС университетов",
        obj3: "10 000 мобилизованных студентов",
        obj4: "1 ежегодный форум Африка–Русскоязычие",
        obj5: "1 стратегический отчёт ежегодно",
      },
    },
    // Programs Page
    programs: {
      title: "Наши программы",
      subtitle: "Стратегические инициативы для континентального развития",
      program1: {
        title: "Программа 10 000 русскоговорящих студентов",
        subtitle: "Горизонт 2035",
        description: "Обучить 10 000 африканских студентов в российских и БРИКС университетах к 2035 году, создавая новое поколение многоязычных специалистов.",
        features: ["Стипендии", "Курсы русского языка", "Культурная поддержка", "Трудоустройство"],
      },
      program2: {
        title: "Программа Бизнес Африка–Россия",
        subtitle: "Экономическое сотрудничество",
        description: "Содействие торговым обменам и перекрёстным инвестициям между африканскими и российскими компаниями.",
        features: ["Экономические миссии", "Бизнес-форумы", "Финансирование проектов", "Юридическая помощь"],
      },
      program3: {
        title: "Программа молодых дипломатов",
        subtitle: "Подготовка высшего уровня",
        description: "Подготовка нового поколения африканских дипломатов по вопросам многополярных отношений.",
        features: ["Дипломатические семинары", "Стажировки в посольствах", "Симуляции ООН", "Международная сеть"],
      },
    },
    // Publications Page
    publications: {
      title: "Публикации",
      subtitle: "Стратегические анализы и отчёты",
      categories: {
        all: "Все",
        rapport: "Годовые отчёты",
        note_strategique: "Стратегические записки",
        analyse_geopolitique: "Геополитические анализы",
      },
      readMore: "Читать далее",
      views: "просмотров",
      noArticles: "Публикации пока недоступны.",
    },
    // Partners Page
    partners: {
      title: "Наши партнёры",
      subtitle: "Сеть ведущих учреждений",
      categories: {
        all: "Все",
        universite_russe: "Российские университеты",
        institution_africaine: "Африканские учреждения",
        chambre_commerce: "Торговые палаты",
        think_tank: "Аналитические центры",
      },
      visitWebsite: "Посетить сайт",
    },
    // Contact Page
    contact: {
      title: "Свяжитесь с нами",
      subtitle: "Мы вас слушаем",
      form: {
        name: "Полное имя",
        email: "Email",
        organization: "Организация (необязательно)",
        subject: "Тема",
        message: "Ваше сообщение",
        submit: "Отправить",
        success: "Сообщение отправлено!",
        error: "Ошибка отправки",
      },
      info: {
        title: "Контактная информация",
        address: "Штаб-квартира",
        addressValue: "Банги, Центральноафриканская Республика",
        email: "Email",
        phone: "Телефон",
      },
    },
    // Network Page
    network: {
      title: "Континентальная сеть",
      subtitle: "Панафриканское присутствие и глобальные партнёрства",
      representations: {
        title: "Национальные представительства",
        description: "ОАР имеет представительства в нескольких африканских странах, координируя местную деятельность и облегчая обмены.",
      },
      centers: {
        title: "Партнёрские центры",
        description: "Центры обучения и сотрудничества, созданные в партнёрстве с местными учреждениями.",
      },
      universities: {
        title: "Аффилированные университеты",
        description: "Сеть партнёрских университетов в России и странах БРИКС, предлагающих программы для африканских студентов.",
      },
    },
    // Common
    common: {
      learnMore: "Узнать больше",
      backToHome: "На главную",
      loading: "Загрузка...",
    },
    // Membership Page
    membership: {
      heroTitle: "Присоединяйтесь к Африканской архитектуре русскоязычного сотрудничества",
      heroSubtitle: "ОАР объединяет новое поколение африканских лидеров, студентов и предпринимателей, связанных с русскоязычным миром на равных.",
      formulas: "Наши тарифные планы",
      standard: {
        title: "Студент / Стандартный член",
        price: "10",
        period: "USD / год",
        tagline: "Доступно. Стратегически. Дальновидно.",
        benefits: [
          "Приоритетный доступ к информации о российских стипендиях",
          "Академическая ориентация в партнёрских университетах",
          "Приглашение на геополитические вебинары ОАР",
          "Ежемесячный стратегический бюллетень",
          "Официальный цифровой сертификат члена",
          "Интеграция в национальную сеть ОАР в вашей стране"
        ],
        cvPosition: "Позиционирование в резюме: Член Африканской организации русскоязычия (ОАР)"
      },
      premium: {
        title: "Премиум-член",
        price: "25",
        period: "USD / год",
        tagline: "Приоритетный. Связанный. Влиятельный.",
        allStandard: "Все преимущества Standard +",
        benefits: [
          "Приоритетный доступ к продвинутым академическим возможностям",
          "Связь с экономическими партнёрами и экспертами",
          "Доступ к полным стратегическим отчётам ОАР",
          "Приоритетное приглашение на очные мероприятия",
          "Проверяемый цифровой значок Premium",
          "Возможность стать местным координатором"
        ],
        limited: "Ограниченное количество мест",
        remaining: "мест осталось в этом году"
      },
      whyJoin: {
        title: "Почему стоит вступить в ОАР?",
        subtitle: "Потому что мир меняется. И те, кто предвидит новые альянсы, опережают события.",
        points: [
          "В континентальной сети",
          "В многополярной динамике",
          "В логике конкретных возможностей"
        ],
        positioning: "ОАР позиционирует вас:"
      },
      countryBenefits: {
        title: "Преимущества в вашей стране",
        intro: "Став членом ОАР в вашей стране:",
        points: [
          "Вы присоединяетесь к официальной местной сети",
          "Вы участвуете в национальных встречах",
          "Вы получаете доступ к образовательным и экономическим возможностям",
          "Вы становитесь стратегическим связующим звеном Африка-Русскоязычие"
        ],
        network: "ОАР работает через структурированную континентальную сеть. Каждая страна становится узлом."
      },
      form: {
        title: "Форма членства",
        firstName: "Имя",
        lastName: "Фамилия",
        email: "Email",
        phone: "Телефон",
        country: "Страна",
        city: "Город",
        profession: "Профессия",
        organization: "Организация",
        membershipType: "Тип членства",
        paymentMethod: "Способ оплаты",
        card: "Карта Visa / Mastercard",
        crypto: "Крипто (USDT TRC20)",
        submit: "Перейти к оплате",
        processing: "Обработка..."
      },
      payment: {
        title: "Оплата",
        methods: "Принимаемые методы:",
        secure: "Безопасная оплата.",
        afterPayment: "После оплаты:",
        steps: [
          "Автоматическое письмо подтверждения",
          "Уникальный номер члена",
          "Официальный PDF сертификат",
          "Доступ к личному кабинету"
        ]
      },
      crypto: {
        title: "Крипто-оплата",
        instructions: "Отправьте точную сумму на следующий адрес:",
        network: "Сеть: USDT TRC20",
        amount: "Сумма:",
        address: "Адрес кошелька:",
        confirm: "После оплаты нажмите 'Подтвердить оплату'",
        confirmBtn: "Я совершил оплату"
      },
      finalMessage: {
        title: "История строится не на периферии.",
        text: "Она строится в центре новых мировых балансов. ОАР объединяет тех, кто хочет предвидеть, понимать и действовать.",
        cta: "Присоединяйтесь к континентальной сети сегодня."
      },
      membersByCountry: "Члены по странам",
      success: {
        title: "Членство оформлено!",
        memberNumber: "Ваш номер члена:",
        emailSent: "Письмо подтверждения отправлено.",
        certificate: "Ваш сертификат будет доступен в личном кабинете."
      }
    },
    // WhatsApp раздел
    whatsapp: {
      title: "Присоединяйтесь к нашему WhatsApp-сообществу",
      description: "Оставайтесь на связи с ОАР. Получайте последние новости, возможности и мероприятия прямо на свой телефон.",
      cta: "Присоединиться к каналу",
      community: "Континентальное сообщество",
      updates: "Обновления в реальном времени",
    },
    // Student Application
    studentApplication: {
      title: "Программа 10 000 русскоговорящих студентов",
      subtitle: "Подайте заявку на обучение в российских и БРИКС университетах",
      form: {
        personalInfo: "Личная информация",
        firstName: "Имя",
        lastName: "Фамилия",
        email: "Email",
        phone: "Телефон",
        dateOfBirth: "Дата рождения",
        country: "Страна",
        city: "Город",
        academicInfo: "Академическая информация",
        currentLevel: "Текущий уровень образования",
        levels: {
          lycee: "Средняя школа / Аттестат",
          licence: "Бакалавриат",
          master: "Магистратура",
          doctorat: "Докторантура"
        },
        fieldOfStudy: "Область обучения",
        targetDegree: "Желаемая степень",
        preferredUniversities: "Предпочтительные университеты",
        russianLevel: "Уровень русского",
        russianLevels: {
          debutant: "Начинающий",
          intermediaire: "Средний",
          avance: "Продвинутый"
        },
        motivation: "Мотивационное письмо",
        submit: "Подать заявку",
        success: "Заявка успешно подана!",
        applicationNumber: "Номер заявки:"
      }
    },
    // Donate Page
    donate: {
      title: "Сделать пожертвование",
      subtitle: "Хотите поддержать нас, наши инициативы, программы или мероприятия, не становясь членом? Сделайте пожертвование и внесите вклад в нашу миссию.",
      description: "Ваша щедрость помогает нам продолжать нашу миссию сотрудничества между Африкой и русскоязычным миром. Каждый вклад, независимо от размера, меняет жизнь тысяч африканских студентов и профессионалов.",
      cardPayment: "Оплата картой",
      cardDescription: "Платите легко и безопасно с помощью Visa или Mastercard через Paystack.",
      cryptoPayment: "Крипто-оплата",
      cryptoDescription: "Пожертвуйте в криптовалюте USDT в сети TRC20 (Tron).",
      cardTitle: "Пожертвование банковской картой",
      cardInstructions: "Нажмите кнопку ниже, чтобы сделать безопасное пожертвование через Paystack.",
      cardButton: "Пожертвовать сейчас",
      securePayment: "Безопасный платёж через Paystack",
      cryptoTitle: "Пожертвование в криптовалюте",
      network: "Сеть",
      walletAddress: "Адрес кошелька",
      copied: "Адрес скопирован!",
      scanQR: "Сканируйте QR-код для отправки пожертвования",
      important: "Важно",
      cryptoWarning: "Отправляйте только USDT в сети TRC20 (Tron). Отправка других криптовалют может привести к потере средств.",
      thankYou: "Спасибо за вашу щедрость и поддержку нашей миссии!",
    },
  },
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let result = translations[lang];
  for (const k of keys) {
    result = result?.[k];
  }
  return result || key;
};
